import { createSlice } from "@reduxjs/toolkit";
import { getPropertiesEntry, saveVisualizationPost } from "../requests";
import { designTypes } from "../../constants/common";

const initialState = {
  imgQrLink: null,
  downloadQrType: "png",
  qrSize: 1000,
  designType: designTypes.base,
  trialStep: null,
  isValidLandingQr: false,
};

const customizeQr = createSlice({
  name: "customizeQr",
  initialState,
  reducers: {
    resetImgQrLink(state) {
      state.imgQrLink = null;
    },
    setDownloadQrType(state, { payload }) {
      state.downloadQrType = payload;
    },
    setQrSize(state, { payload }) {
      state.qrSize = payload;
    },
    setDesignType(state, { payload }) {
      state.designType = payload;
    },
    setTrialStep(state, { payload }) {
      state.trialStep = payload;
    },
    setIsValidLandingQr(state, { payload }) {
      state.isValidLandingQr = payload;
    },
  },
  extraReducers: {
    [saveVisualizationPost.fulfilled]: (state, { payload }) => {
      if (payload.includes("http")) state.imgQrLink = payload;
    },
    [getPropertiesEntry.fulfilled]: (state, { payload }) => {
      if (payload.data.designType) {
        state.designType = payload.data.designType;
      }
    },
  },
});
export const {
  resetImgQrLink,
  setDownloadQrType,
  setQrSize,
  setDesignType,
  setTrialStep,
  setIsValidLandingQr,
} = customizeQr.actions;
export default customizeQr.reducer;
